import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { title } from "../config/Config";

// img imports

import logo from "../Assets/Images/logo.png";
import order_img from "../Assets/Images/product_img1.jpg";

const modalContent = {
    refund: {
        title: "Refund Policy",
        content: `We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.

To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You'll also need the receipt or proof of purchase.

To start a return, you can contact us at thenaturalayurveda@gmail.com. Please note that returns will need to be sent to the following address: [INSERT RETURN ADDRESS]

If your return is accepted, we'll send you a return shipping label, as well as instructions on how and where to send your package. Items sent back to us without first requesting a return will not be accepted.

You can always contact us for any return question at thenaturalayurveda@gmail.com.

Damages and issues
Please inspect your order upon reception and contact us immediately if the item is defective, damaged or if you receive the wrong item, so that we can evaluate the issue and make it right.

Exceptions / non-returnable items
Certain types of items cannot be returned, like perishable goods (such as food, flowers, or plants), custom products (such as special orders or personalized items), and personal care goods (such as beauty products). We also do not accept returns for hazardous materials, flammable liquids, or gases. Please get in touch if you have questions or concerns about your specific item.

Unfortunately, we cannot accept returns on sale items or gift cards.

Exchanges
The fastest way to ensure you get what you want is to return the item you have, and once the return is accepted, make a separate purchase for the new item.

European Union 14 day cooling off period
Notwithstanding the above, if the merchandise is being shipped into the European Union, you have the right to cancel or return your order within 14 days, for any reason and without a justification. As above, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You'll also need the receipt or proof of purchase.

Refunds
We will notify you once we've received and inspected your return, and let you know if the refund was approved or not. If approved, you'll be automatically refunded on your original payment method within 10 business days. Please remember it can take some time for your bank or credit card company to process and post the refund too. If more than 15 business days have passed since we've approved your return, please contact us at thenaturalayurveda@gmail.com.`,
    },
    shipping: {
        title: "Shipping Policy",
        content: `Welcome to {title}! We are committed to delivering high-quality Ayurvedic products across India with a seamless and hassle-free shipping experience.

Shipping Coverage
We offer shipping services PAN India, covering all states and major cities. However, delivery to certain remote locations may be subject to availability.

Order Processing Time
Orders are processed within 1-2 business days after confirmation. Orders placed on weekends or public holidays will be processed on the next working day. You will receive an email or SMS notification with tracking details once your order is dispatched.

Delivery Timeframe
Within Punjab: 4-6 business days
Metro Cities (Delhi, Mumbai, Bangalore, etc.): 5-7 business days
Rest of India: 6-9 business days

Delivery timelines may vary due to unforeseen circumstances such as weather conditions, strikes, or operational delays by courier partners.

Order Tracking
Once your order is shipped, you will receive a tracking link via email/SMS. You can also track your order on our website under the 'Track Order' section using your order ID.

Undelivered & Returned Orders
If the order is undelivered due to incorrect address/contact details, we will attempt re-delivery. If the order is returned due to non-acceptance, further shipping may require additional confirmation from the customer.

Damaged or Missing Items
If you receive a damaged or incorrect product, contact our support team within 48 hours of delivery with images and order details. We will arrange a replacement or initiate a refund as per our return policy.

Customer Support
Website: www.naturalayurveda.com
Email: thenaturalayurveda@gmail.com
Phone: +91 9115955665
Live Chat: Available on our website during business hours

We appreciate your trust in {title} and strive to deliver the best Ayurvedic products to your doorstep!`,
    },
    privacy: {
        title: "Privacy Policy",
        content: `Last updated: October 11, 2025

{title} operates this store and website, including all related information, content, features, tools, products and services, in order to provide you, the customer, with a curated shopping experience (the "Services"). {title} is powered by Shopify, which enables us to provide the Services to you. This Privacy Policy describes how we collect, use, and disclose your personal information when you visit, use, or make a purchase or other transaction using the Services or otherwise communicate with us.

Personal Information We Collect or Process
We may collect or process the following categories of personal information:
- Contact details including your name, address, billing address, shipping address, phone number, and email address.
- Financial information including credit card, debit card, and financial account numbers.
- Account information including your username, password, security questions, preferences and settings.
- Transaction information including the items you view, put in your cart, or purchase.
- Communications with us including the information you include in communications with us.
- Device information including information about your device, browser, or network connection.
- Usage information including information regarding your interaction with the Services.

How We Use Your Personal Information
- Provide, Tailor, and Improve the Services.
- Marketing and Advertising.
- Security and Fraud Prevention.
- Communicating with You.
- Legal Reasons.

How We Disclose Personal Information
In certain circumstances, we may disclose your personal information to third parties for legitimate purposes subject to this Privacy Policy, including with Shopify, vendors and other third parties who perform services on our behalf.

Security and Retention of Your Information
Please be aware that no security measures are perfect or impenetrable, and we cannot guarantee "perfect security." How long we retain your personal information depends on different factors, such as whether we need the information to maintain your account or to provide you with Services.

Your Rights and Choices
- Right to Access / Know.
- Right to Delete.
- Right to Correct.
- Right of Portability.
- Managing Communication Preferences.

Contact
Should you have any questions about our privacy practices or this Privacy Policy, please email us at thenaturalayurveda@gmail.com or contact us at Sangrur, PB, 148001, IN.`,
    },
    terms: {
        title: "Terms of Service",
        content: `OVERVIEW
Welcome to {title}! The terms "we", "us" and "our" refer to {title}. By visiting, interacting with or using our Services, you agree to be bound by these Terms of Service and our Privacy Policy.

SECTION 1 - ACCESS AND ACCOUNT
By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence. You are solely responsible for maintaining the security of your account credentials and for all of your account activity.

SECTION 2 - OUR PRODUCTS
We have made every effort to provide an accurate representation of our products and services in our online stores. However, please note that colors or product appearance may differ from how they may appear on your screen. All descriptions of products are subject to change at any time without notice at our sole discretion.

SECTION 3 - ORDERS
When you place an order, you are making an offer to purchase. {title} reserves the right to accept or decline your order for any reason at its discretion. Your order is not accepted until {title} confirms acceptance.

SECTION 4 - PRICES AND BILLING
Prices, discounts and promotions are subject to change without notice. The price charged for a product or service will be the price in effect at the time the order is placed and will be set out in your order confirmation email.

SECTION 5 - SHIPPING AND DELIVERY
We are not liable for shipping and delivery delays. All delivery times are estimates only and are not guaranteed. We are not responsible for delays caused by shipping carriers, customs processing, or events outside our control.

SECTION 6 - INTELLECTUAL PROPERTY
Our Services, including but not limited to all trademarks, brands, text, displays, images, graphics, product reviews, video, and audio, are owned by {title}, its affiliates or licensors and are protected by copyright and other intellectual property laws.

SECTION 13 - PROHIBITED USES
You may access and use the Services for lawful purposes only. You may not access or use the Services for any unlawful or malicious purpose, to violate any regulations, to infringe upon intellectual property rights, or to transmit false or misleading information.

SECTION 15 - DISCLAIMER OF WARRANTIES
THE SERVICES AND ALL PRODUCTS OFFERED THROUGH THE SERVICES ARE PROVIDED 'AS IS' AND 'AS AVAILABLE' FOR YOUR USE, WITHOUT ANY REPRESENTATION, WARRANTIES OR CONDITIONS OF ANY KIND.

SECTION 16 - LIMITATION OF LIABILITY
TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO CASE SHALL {title} BE LIABLE FOR ANY INJURY, LOSS, CLAIM, OR ANY DIRECT, INDIRECT, INCIDENTAL, PUNITIVE, SPECIAL, OR CONSEQUENTIAL DAMAGES OF ANY KIND.

SECTION 24 - CONTACT INFORMATION
Questions about the Terms of Service should be sent to us at thenaturalayurveda@gmail.com.`,
    },
};



function CheckMain() {
    const [tip, setTip] = useState(0);
    const [total, setTotal] = useState(0);

    // handle input change
    const handleChange = (e) => {
        setTip(Number(e.target.value) || 0);
    };

    // increase
    const increase = () => {
        setTip((prev) => prev + 1);
    };

    // decrease
    const decrease = () => {
        setTip((prev) => (prev > 0 ? prev - 1 : 0));
    };

    // add tip to total
    const addTip = () => {
        setTotal((prev) => prev + tip);
        setTip(0);
    };


    const [activeModal, setActiveModal] = useState(null);

    const openModal = (key) => setActiveModal(key);
    const closeModal = () => setActiveModal(null);

    return (
        <>
            <div className="checkout-sec">
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="checkout_nav">
                                <img src={logo} alt="logo" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="chech_main">
                <Container fluid>
                    <Row>
                        <Col lg={6}>
                            <div className="checkout_frm">
                                <div className="check_form_box">
                                    {/* Contact */}
                                    <div className="contact_heading">
                                        <h5>Contact</h5>
                                        <a href="#">Sign in</a>
                                    </div>
                                    <Row>
                                        <Col xs={12}>
                                            <div className="form_group">
                                                <input
                                                    type="text"
                                                    placeholder="Email or mobile phone number"
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="form_check">
                                                <input type="checkbox" id="emailOffers" defaultChecked />
                                                <label htmlFor="emailOffers">
                                                    Email me with news and offers
                                                </label>
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Delivery */}
                                    <div className="section_heading">
                                        <h5>Delivery</h5>
                                    </div>
                                    <Row>
                                        <Col xs={12}>
                                            <div className="form_group select_group">
                                                <select>
                                                    <option>India</option>
                                                    <option>USA</option>
                                                    <option>UK</option>
                                                </select>
                                                <span className="select_label">Country/Region</span>
                                            </div>
                                        </Col>
                                        <Col xs={6}>
                                            <div className="form_group">
                                                <input type="text" placeholder="First name (optional)" />
                                            </div>
                                        </Col>
                                        <Col xs={6}>
                                            <div className="form_group">
                                                <input type="text" placeholder="Last name" />
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="form_group input_icon">
                                                <input type="text" placeholder="Address" />
                                                <i className="fa-solid fa-magnifying-glass"></i>
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="form_group">
                                                <input
                                                    type="text"
                                                    placeholder="Apartment, suite, etc. (optional)"
                                                />
                                            </div>
                                        </Col>
                                        <Col xs={4}>
                                            <div className="form_group">
                                                <input type="text" placeholder="City" />
                                            </div>
                                        </Col>
                                        <Col xs={4}>
                                            <div className="form_group select_group">
                                                <select>
                                                    <option>Punjab</option>
                                                    <option>Delhi</option>
                                                    <option>Maharashtra</option>
                                                </select>
                                                <span className="select_label">State</span>
                                            </div>
                                        </Col>
                                        <Col xs={4}>
                                            <div className="form_group">
                                                <input type="text" placeholder="PIN code" />
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="form_group input_icon">
                                                <input type="tel" placeholder="Phone" />
                                                <i className="fa-solid fa-circle-question"></i>
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <div className="form_check">
                                                <input type="checkbox" id="saveInfo" />
                                                <label htmlFor="saveInfo">
                                                    Save this information for next time
                                                </label>
                                            </div>
                                        </Col>
                                        {/* <Col xs={12}>
                                <div className="form_check">
                                    <input type="checkbox" id="textOffers" />
                                    <label htmlFor="textOffers">Text me with news and offers</label>
                                </div>
                            </Col> */}
                                    </Row>

                                    {/* Shipping Method */}
                                    <div className="section_heading">
                                        <h5>Shipping method</h5>
                                    </div>
                                    <Row>
                                        <Col xs={12}>
                                            <div className="shipping_info">
                                                <p>
                                                    Enter your shipping address to view available shipping
                                                    methods.
                                                </p>
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* Payment Section */}
                                    <div className="payment_section">
                                        {/* Payment */}
                                        <div className="section_heading">
                                            <h5>Payment</h5>
                                            <p>All transactions are secure and encrypted.</p>
                                        </div>

                                        <div className="payment_methods">
                                            <div className="payment_option active">
                                                <div className="option_left">
                                                    <input
                                                        type="radio"
                                                        name="payment"
                                                        id="razorpay"
                                                        defaultChecked
                                                    />
                                                    <label htmlFor="razorpay">
                                                        Razorpay Secure (UPI, Cards, Int'l Cards, Wallets)
                                                    </label>
                                                </div>
                                                <div className="payment_icons">
                                                    <span className="pay_badge">UPI</span>
                                                    <span className="pay_badge">VISA</span>
                                                    <span className="pay_badge master">●●</span>
                                                    <span className="pay_badge">+18</span>
                                                </div>
                                            </div>
                                            <div className="razorpay_info">
                                                <p>
                                                    You'll be redirected to Razorpay Secure (UPI, Cards, Int'l
                                                    Cards, Wallets) to complete your purchase.
                                                </p>
                                            </div>
                                            <div className="payment_option">
                                                <input type="radio" name="payment" id="cod" />
                                                <label htmlFor="cod">Cash on Delivery (COD)</label>
                                            </div>
                                        </div>

                                        {/* Billing Address */}
                                        <div className="section_heading mt">
                                            <h5>Billing address</h5>
                                        </div>

                                        <div className="payment_methods">
                                            <div className="payment_option active">
                                                <input
                                                    type="radio"
                                                    name="billing"
                                                    id="same"
                                                    defaultChecked
                                                />
                                                <label htmlFor="same">Same as shipping address</label>
                                            </div>
                                        </div>

                                        {/* Add Tip */}
                                        <div className="section_heading mt">
                                            <h5>Add tip</h5>
                                        </div>

                                        <div className="tip_box">
                                            <div className="tip_check">
                                                <input type="checkbox" id="tipCheck" defaultChecked />
                                                <label htmlFor="tipCheck">
                                                    Show your support for the team at {title}
                                                </label>
                                            </div>

                                            <div className="tip_options">
                                                <div className="tip_btn">
                                                    <span className="tip_percent">10%</span>
                                                    <span className="tip_amount">₹89.90</span>
                                                </div>
                                                <div className="tip_btn">
                                                    <span className="tip_percent">15%</span>
                                                    <span className="tip_amount">₹134.85</span>
                                                </div>
                                                <div className="tip_btn">
                                                    <span className="tip_percent">20%</span>
                                                    <span className="tip_amount">₹179.80</span>
                                                </div>
                                            </div>

                                            <div className="form_group custom_tip">
                                                <input
                                                    type="number"
                                                    placeholder="Custom tip"
                                                    value={tip}
                                                    onChange={handleChange}
                                                />

                                                <div className="tip_controls">
                                                    <button onClick={decrease}>−</button>
                                                    <button onClick={increase}>+</button>
                                                </div>

                                                <button className="add_tip_btn" onClick={addTip}>
                                                    Add Tip
                                                </button>
                                            </div>

                                            <p className="tip_thanks">Thank you, we appreciate it.</p>
                                        </div>

                                        {/* Pay Now */}
                                        <button className="pay_now_btn">Pay now</button>
                                    </div>

                                    <div className="footer_links">
                                        <div className="footer_divider" />
                                        <div className="footer_nav">
                                            <button onClick={() => openModal("refund")}>Refund policy</button>
                                            <button onClick={() => openModal("shipping")}>Shipping</button>
                                            <button onClick={() => openModal("privacy")}>Privacy policy</button>
                                            <button onClick={() => openModal("terms")}>Terms of service</button>
                                        </div>
                                    </div>

                                    {/* Modal */}
                                    {activeModal && (
                                        <div className="modal_overlay" onClick={closeModal}>
                                            <div className="modal_box" onClick={(e) => e.stopPropagation()}>
                                                <div className="modal_header">
                                                    <h4>{modalContent[activeModal].title}</h4>
                                                    <button className="modal_close" onClick={closeModal}>
                                                        <i className="fa-solid fa-xmark" />
                                                    </button>
                                                </div>
                                                <div className="modal_body">
                                                    {modalContent[activeModal].content
                                                        .split("\n\n")
                                                        .map((para, i) => (
                                                            <p key={i}>{para}</p>
                                                        ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>

                        <Col lg={6}>
                            <div className="order_summary">
                                {/* Product */}
                                <div className="order_product">
                                    <div className="product_img_wrap">
                                        <img src={order_img} alt="Product" />
                                        <span className="product_qty">1</span>
                                    </div>
                                    <div className="product_details">
                                        <p>
                                            Light N Care Anti Blemish Cream – Ayurvedic Formula with Green
                                            Tea & Aloe Vera Extract (50g)
                                        </p>
                                    </div>
                                    <div className="product_price">
                                        <span>₹899.00</span>
                                    </div>
                                </div>

                                <div className="order_divider" />

                                {/* Subtotal */}
                                <div className="order_row">
                                    <span className="order_label">Subtotal</span>
                                    <span className="order_value">₹899.00</span>
                                </div>

                                {/* Shipping */}
                                <div className="order_row">
                                    <span className="order_label">
                                        Shipping
                                        <i className="fa-regular fa-circle-question" />
                                    </span>
                                    <span className="order_value muted">Enter shipping address</span>
                                </div>

                                <div className="order_divider" />

                                {/* Total */}
                                <div className="order_row total_row">
                                    <span className="order_label total_label">Total</span>
                                    <div className="total_right">
                                        <span className="currency_label">INR</span>
                                        <span className="total_price">₹899.00</span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>


        </>
    );
}
export default CheckMain;
